// A DÓNDE SE SALE CUANDO SE ACABA UNA SESIÓN, Y QUÉ APP SE INSTALA DESDE CADA PORTAL (t264c, 16-oct-2026)
//
// El dueño: «que cuando cierran sesión en /lab les redirija a /lab/entrar, ya que muchos instalan la app y no quiero que les
// lleve nunca al login de las clínicas». Tres piezas, en un solo sitio para que no se separen:
//
//  1 · `salidaDelEquipo(ruta)`: a dónde manda el interceptor GENERAL (services/api.js, la sesión del equipo) cuando esa sesión
//      se ha muerto. Solo a /login desde las pantallas del equipo. Desde un portal con su propia sesión —el del paciente
//      (/portal) y el del laboratorio (/lab)— NO se mueve a nadie: allí convive la sesión del portal con una del equipo que
//      pueda haber en el navegador, y un 401 de esa en segundo plano no puede sacar al laboratorio de su portal ni llevarle al
//      login de las clínicas. El del laboratorio se va a su entrada por su propio cliente (services/apiLaboratorio.js).
//      Y si ya se está en /login, tampoco (reasignar la misma dirección recarga la página).
//  2 · `esDelLaboratorio(ruta)`: /lab y lo que cuelga de /lab/ (nunca /laboratorio, que es la pantalla de la clínica).
//  3 · `ponerManifiestoDelLaboratorio(doc, ruta)`: en las páginas del laboratorio, el manifiesto de SU app instalable
//      (public/manifest-lab.json: «Biango Laboratorio», start_url y scope /lab/). index.html enlaza el de las clínicas
//      (/manifest.json, start_url /); main.jsx llama a esto antes de pintar, y solo en /lab: el de las clínicas y el del
//      portal del paciente no se tocan. Así quien instala el portal desde /lab abre siempre su portal.
export const ENTRADA_LAB = '/lab/entrar'
export const MANIFIESTO_LAB = '/manifest-lab.json'
export const NOMBRE_APP_LAB = 'Biango Laboratorio'

export function esDelLaboratorio(ruta) {
  const p = String(ruta || '')
  return p === '/lab' || p.startsWith('/lab/') || p.startsWith('/lab?')
}

export function salidaDelEquipo(ruta) {
  const p = String(ruta || '')
  if (p.startsWith('/portal') || esDelLaboratorio(p) || p === '/login') return null
  return '/login'
}

// B-2270 (28-oct-2026) · Y EL DEL PORTAL DEL PACIENTE (public/manifest-portal.json: «Portal del paciente», start_url y scope
// /portal), solo en /portal y lo que cuelga de /portal/ (la entrada, la activación y el portal). Con el de las clínicas,
// «Añadir a la pantalla de inicio» desde el portal abría el login del EQUIPO (start_url /): ahora abre su portal. Lo ofrece
// utils/accesoPortal (AnadirAPantallaDeInicio), que mira que esta página lleve este manifiesto antes de decir «Instalar».
export const MANIFIESTO_PACIENTE = '/manifest-portal.json'
export const NOMBRE_APP_PACIENTE = 'Mi portal'
export function esDelPortalDelPaciente(ruta) {
  const p = String(ruta || '')
  return p === '/portal' || p.startsWith('/portal/') || p.startsWith('/portal?')
}
export function ponerManifiestoDelPaciente(doc, ruta) {
  if (!doc || !esDelPortalDelPaciente(ruta)) return false
  try {
    const enlace = doc.querySelector('link[rel="manifest"]')
    if (enlace) enlace.setAttribute('href', MANIFIESTO_PACIENTE)
    const titulo = doc.querySelector('meta[name="apple-mobile-web-app-title"]')
    if (titulo) titulo.setAttribute('content', NOMBRE_APP_PACIENTE)
    return !!enlace
  } catch (_) { return false }
}

export function ponerManifiestoDelLaboratorio(doc, ruta) {
  if (!doc || !esDelLaboratorio(ruta)) return false
  try {
    const enlace = doc.querySelector('link[rel="manifest"]')
    if (enlace) enlace.setAttribute('href', MANIFIESTO_LAB)
    const titulo = doc.querySelector('meta[name="apple-mobile-web-app-title"]')
    if (titulo) titulo.setAttribute('content', NOMBRE_APP_LAB)
    return !!enlace
  } catch (_) { return false }
}
